import React from 'react';
import { Box } from '@mui/material';
import Card from '@mui/material/Card';
import Container from '@mui/material/Container';
import { Button, PermissionFilter  } from '@timmons-group/shared-react-components';
import { useLocalStorage } from '@timmons-group/shared-react-components/hooks';
import ActionBar from '../components/ActionBar';
import Stack from '@mui/material/Stack';
import Tabber from '../components/Tabber';
import TabberPanel from '../components/TabberPanel';
import { useNavigate } from 'react-router-dom';
import IndividualRecipientsGrid from 'features/Recipient/IndividualRecipientsGrid';
import OrganizationRecipientsGrid from 'features/OrgRecipient/OrganizationRecipientsGrid';
import { ACLS, LOCAL_STORAGE_KEYS } from 'constants';

// Tabs are defined here for the sub header
const tabs = [{ index: 0, label: 'Individuals' }, { index: 1, label: 'Organizations' }];

// Button titles based on tab index
const buttonTitles = { 0: 'Individual', 1: 'Organization' };

// Function that gets title based on tab index
const getTitle = (tabIndex) => buttonTitles[tabIndex];

// Main component
const Recipients = () => {
  const [tabIndex, setTabIndex] = useLocalStorage(LOCAL_STORAGE_KEYS.RECIPIENT_TABBER, 0);
  const nav = useNavigate();

  // Function for handling the tab change
  const handleChange = (newValue) => {
    setTabIndex(newValue);
  };

  // Handle add button click
  const handleAddClick = () => {
    // if individual, navigate to create individual
    if (getTitle(tabIndex) === buttonTitles[0]) nav('/recipients/create');

    // if organization, navigate to create organization
    if (getTitle(tabIndex) === buttonTitles[1]) nav('/orgrecipients/create');
  };

  return (
    <>
      {/* 🚀 Sub header action bar */}
      <ActionBar
        leftRender={
          () =>
            <Stack spacing={2} direction="row" justifyContent="flex-start">
              <Tabber
                index={tabIndex}
                tabs={tabs}
                onChange={handleChange}
              />
            </Stack>
        }
        rightRender={
          () =>
            <PermissionFilter permission={(getTitle(tabIndex) === 'Individual'? ACLS.CREATE_RECIP : ACLS.CREATE_ORG_RECIP)}>
              <Stack spacing={2} direction="row" justifyContent="flex-end">
                <Button color="secondary" label={`Add ${getTitle(tabIndex)} Recipient`} onClick={handleAddClick} />
              </Stack>
            </PermissionFilter>
        }
      />

      {/* 🌏 Main content */}
      <Box px={7}>
        <Container maxWidth={false} sx={{ marginTop: 2 }}>
          <Card>
            <TabberPanel value={tabIndex} index={0}>
              <IndividualRecipientsGrid />
            </TabberPanel>
            <TabberPanel value={tabIndex} index={1}>
              <OrganizationRecipientsGrid />
            </TabberPanel>
          </Card>
        </Container>
      </Box>
    </>
  );
}

export default Recipients;
